import * as angular from 'angular';
import { ComponentDefinition } from '../../models';

class LabelsEditorController implements angular.IComponentController {

    isLoading: boolean;
    model: string[];
    onChange?: () => void;
    static $inject = ['$translate'];

    constructor(private readonly _$translate: angular.translate.ITranslateService) {
    }

    onSelect($item: string, $model: string) {
        const toReplace = ` ${this._$translate.instant('(Enter to create)')}`;
        this.model = this.model.map(d => d.replace(toReplace, ''));
        this.propagateChange();
    }

    onRemove() {
        this.propagateChange();
    }

    private propagateChange() {
        if (this.onChange) {
            this.onChange();
        }
    }
}

export const wtLabelsEditor: ComponentDefinition = {
    componentId: 'wtLabelsEditor',
    controller: LabelsEditorController,
    controllerAs: 'vm',
    template: require('./labelsEditor.component.html'),
    bindings: {
        model: '=',
        list: '<',
        name: '@?',
        formController: '<?',
        placeholder: '@',
        disabled: '&?',
        onChange: '&?'
    }
};